import { call, put, select } from 'redux-saga/effects';
import { convertToKebabCase } from '@bitComponents/utils/htmlUtils';
import { normalizeString } from '@bitComponents/utils/common';
import { MOBILE_INSURANCE } from '../bitConstants/constants';
import { initCardPayment as initCardPaymentBit } from '../bitSagas/initCardPayment';
import { initFinancedPayment as initFinancedPaymentBit } from '../bitSagas/initFinancedPayment';
import { getCardPaymentError as getCardPaymentErrorBit } from '../bitSagas/getCardPaymentError';
import { checkFinancedPaymentStatusLoopGenerator as checkFinancedPaymentStatusLoopGeneratorBit } from '../bitSagas/checkFinancedPaymentStatusLoopGenerator';
import { actions as uiNeedsActions } from '../reducers/uiNeeds';

const apiNeeds = state => state.apiNeeds;
const offer = state => state.offer;
const getErrorManagement = state => state.errorManagement;
const { NS_OPTION } = MOBILE_INSURANCE;

export function* initCardPayment(params) {
  const { cqId } = yield select(apiNeeds);
  const { normalizeHttpErrors, showError } = params;

  const initCardPaymentParams = {
    cqId,
    reduxUpdate: {
      successUpdate: uiNeedsActions.setCardPaymentInfo,
      errorUpdate: showError,
    },
    normalizeHttpErrors,
  };
  yield call(initCardPaymentBit, initCardPaymentParams);

  return null;
}

export function* initFundedPayment(params) {
  const { cqId, fundingInfo } = yield select(apiNeeds);

  const { handledErrors } = yield select(getErrorManagement);
  const { selectedFundingOffer, selectedMobileLine } = fundingInfo;
  const { months, rateCode, taxVersion } = selectedFundingOffer;

  const { normalizeHttpErrors, showError } = params;

  const initFinancedPaymentParams = {
    reduxUpdate: {
      errorUpdate: showError,
    },
    normalizeHttpErrors,
    cqId,
    mobileLine: selectedMobileLine,
    months,
    rateCode,
    taxVersion,
  };
  const response = yield call(initFinancedPaymentBit, initFinancedPaymentParams);
  const { idInterno, idSPO } = response;
  const checkFinancedPaymentStatusLoopGeneratorParams = {
    cqId,
    spoId: idSPO,
    internalId: idInterno,
    maxTries: 60,
    reduxUpdate: {
      errorUpdate: showError,
    },
    normalizeHttpErrors,
  };
  const res = yield call(
    checkFinancedPaymentStatusLoopGeneratorBit,
    checkFinancedPaymentStatusLoopGeneratorParams,
  );
  const { urlSupplier } = res;
  if (!urlSupplier) {
    yield put(showError(handledErrors.BUSINESS_ERRORS.FUNDED_URL_ERROR));
  }

  return urlSupplier;
}

export function* getCardPaymentError(params) {
  const {
    cardPaymentErrorCode: idError,
  } = yield select(offer);
  const { normalizeHttpErrors, showError } = params;
  if (idError) {
    const getCardPaymentErrorParams = {
      idError,
      reduxUpdate: {
        successUpdate: uiNeedsActions.setCardPaymentError,
        errorUpdate: showError,
      },
      normalizeHttpErrors,
    };
    yield call(getCardPaymentErrorBit, getCardPaymentErrorParams);
  }
  return null;
}
